// LeafLogix.Web/Dutchie.Common.Domain/Models/Register/Discount/Bundle Discounts/DiscountModel.cs
export type Discount = {
  ApplicationMethodId: ApplicationMethodTypeId;
  CanStackAutomatically: boolean;
  Constraints: Constraint[];
  DiscountCode?: string;
  DiscountDescription: string;
  DiscountMenuDisplayDetails?: DiscountMenuDisplayDetailsModel;
  EndTime?: string;
  ExternalId: string;
  FirstTimeCustomerOnly: number;
  Friday?: boolean;
  Id: number;
  IgnoreNetTax: boolean;
  IsAvailableOnline: boolean;
  IsBundledDiscount: boolean;
  LocationRestrictions: number[];
  LoyaltyPointValue?: number;
  MaxRedemptions?: number | string;
  MenuDisplayRank?: number | null;
  Monday?: boolean;
  OnlineName?: string;
  PaymentRestrictions?: PaymentRestrictions;
  PlatformTypeRestrictions?: DiscountPlatformTypeRestriction[] | null;
  RedemptionLimit?: number | string;
  RequireManagerApproval: boolean;
  RestrictToGroupIds: number[];
  RestrictToSegmentIds: number[];
  Reward: Reward;
  Saturday?: boolean;
  SavedWithAdvancedOptions?: boolean;
  StartTime?: string;
  Sunday?: boolean;
  Thursday?: boolean;
  Tuesday?: boolean;
  ValidDateFrom: string;
  ValidDateTo: string;
  Wednesday?: boolean;
};

export type DiscountPlatformTypeRestriction = {
  // Server sets these; optional on client requests
  DiscountId?: number;
  IsExclusion: boolean;
  LspId?: number;
  PlatformTypeId: number | null;
};

export enum ApplicationMethodTypeId {
  Automatically = 1,
  Manually = 2,
  ByCode = 3,
  BySpringBig = 4,
  ByAlpineIQ = 5,
  ByFyllo = 6,
  ExternalLoyalty = 7,
  DutchieLoyalty = 8,
}

export type Constraint = {
  DiscountConstraintId?: number | null;
  DiscountId: number;
  DiscountItemGroupTypeId?: ItemGroupType;
  IncludeNonCannabis: boolean;
  Restrictions: Restrictions;
  ThresholdMax?: number | null;
  ThresholdMin?: number;
  ThresholdTypeId?: ThresholdType;
};

export enum ThresholdType {
  NoThreshold = 0,
  NumberOfItems = 1,
  SpendingAmount = 2,
  ProductWeight = 3,
}

export enum ItemGroupType {
  All = 5,
  BySKU = 6,
}

export type Restrictions = {
  Brand?: Restriction;
  Category?: Restriction;
  CustomerType?: Restriction;
  InventoryTag?: Restriction;
  Product?: Restriction;
  Strain?: Restriction;
  Tag?: Restriction;
  Tier?: Restriction;
  Vendor?: Restriction;
  Weight?: Restriction;
};

type Restriction = {
  IsExclusion: boolean;
  RestrictionIds: number[];
};

type DiscountMenuDisplayDetailsModel = {
  DiscountId: number;
  DiscountMenuDisplayId?: number | null;
  MenuDisplayDescription: string;
  MenuDisplayImageUrl: string;
  MenuDisplayName: string;
};

export type PaymentRestrictions = {
  PayByBankSignupIncentive: boolean;
};

export type Reward = {
  ApplyToOnlyOneItem: boolean;
  CalculationMethodId: number | null;
  DiscountId?: number;
  DiscountRewardId?: number | null;
  DiscountValue: number;
  HasThreshold?: boolean;
  HighestOrLowest: 'high' | 'low';
  IncludeNonCannabis: boolean;
  ItemGroupTypeId: ItemGroupType;
  ManualDefaultApplyTo: ManualDefaultApplyTo;
  Restrictions: Restrictions;
  ThresholdMax?: number | null;
  ThresholdMin?: number | null;
  ThresholdTypeId?: ThresholdType;
};

export enum CalculationMethods {
  AmountOff = 1,
  PercentOff = 2,
  PriceToAmount = 3,
  PriceToCostPlusPercent = 4,
  AmountOffTotal = 5,
  PriceToAmountTotal = 6,
}

export enum ManualDefaultApplyTo {
  JustOneItem = 1,
  EachItemInRow = 2,
  EveryItemInCart = 3,
  DistributedAmongEveryItem = 4,
}

export enum TotalItemConditionType {
  AtLeast = 0,
  Every = 1,
  Exactly = 2,
  Between = 3,
}

export enum DiscountAppliesTo {
  SameProducts = 1,
  DifferentProducts = 2,
  HighestPricedItem = 3,
  LowestPricedItem = 4,
}

export enum DiscountFirstTimeCustomer {
  NoFirstTimeDiscount = 0,
  ByLocation = 1,
  AllLocations = 2,
}

export enum RewardApplyTo {
  all = 'all',
  high = 'high',
  low = 'low',
}
